import moment from 'moment'
import 'moment/dist/locale/sv'

moment.locale('en')
